<template>
    <v-container id="lobby" v-if="currentModel && !isLoading" class="pt-12">
        <v-row>
            <v-col class="text-center" v-bind:class="{ 'mb-6': !hasChildren }">
                <h1 class="mb-3">{{ currentModel.settings.localizedContent['walkin_queue_welcome_line1_message'] }}</h1>
                <h3 v-if="!hasChildren">{{ currentModel.settings.localizedContent['walkin_queue_welcome_message'] }}</h3>
                <h3 v-else>Please select the location you would like to visit:</h3>
            </v-col>
        </v-row>
        <v-row v-if="hasChildren">
            <v-col class="d-flex justify-center" cols="12">
                <v-select v-model="selectedChild"
                          :allow-overflow="false"
                          :clearable="true"
                          :items="childEntities"
                          height="50"
                          width="70%"
                          label="Location"
                          class="entity-selector"
                          background-color="white"
                          auto-focus="true"
                          outlined
                          solo>
                </v-select>
            </v-col>
        </v-row>
        <transition name="fade">
            <v-row class="actions" v-if="showOnline">
                <v-col class="d-flex justify-center" cols="12">
                    <router-link :to="{ name: 'online', params: { clientId: selectedClientId }}" v-slot="{ href, navigate }" exact replace>
                        <v-btn color="secondary" :disabled="actionsDisabled" @click="navigate" raised>{{ currentModel.settings.localizedContent['walkin_queue_left_button_text'] }} </v-btn>
                    </router-link>
                </v-col>
            </v-row>
        </transition>
        <transition name="fade">
            <v-row class="actions" v-if="showWalkin">
                <v-col class="d-flex justify-center" cols="12">
                    <router-link :to="{ name: 'walkin', params: { clientId: selectedClientId }}" v-slot="{ href, navigate }" exact replace>
                        <v-btn color="primary" :disabled="actionsDisabled" @click="navigate" raised>{{ currentModel.settings.localizedContent['walkin_queue_right_button_text'] }}</v-btn>
                    </router-link>
                </v-col>
            </v-row>
        </transition>
    </v-container>
</template>

<script>
    /*eslint-disable no-debugger*/
    import ContextualMixin from '../mixins/contextualMixin.js'
    export default {
        name: 'Lobby',
        mixins: [ContextualMixin],
        data() {
            return {
                selectedChild: null
            }
        },
        computed: {
            hasChildren() {
                return this.currentModel 
                    && this.currentModel.settings.clientType === 'GROUP' 
                    && this.currentModel.settings.childEntities
                    && this.currentModel.settings.childEntities.length;
            },
            childEntities() {
                if (!this.hasChildren)
                    return [];
                return this.currentModel.settings.childEntities.map(x => {
                    return {
                        text: x.shortClientName || x.clientName,
                        value: x.clientId
                    }
                });
            },
            selectedClientId() {
                return this.selectedChild ? this.selectedChild : this.clientId;
            },
            actionsDisabled() {
                return this.hasChildren && !this.selectedChild;
            },
            showWalkin() {
                if (this.hasChildren && !this.selectedChild)
                    return false;
                else if (this.hasChildren && this.selectedChild) {
                    let entity = this.currentModel.settings.childEntities.filter(x => x.clientId == this.selectedChild);
                    if (entity)
                        return entity[0].showWalkinPatientButton;
                }
                else if (!this.hasChildren && this.currentModel)
                    return this.currentModel.settings.showWalkinPatientButton;
                return true;
            },
            showOnline() {
                if (this.hasChildren && !this.selectedChild)
                    return false;
                else if (this.hasChildren && this.selectedChild) {
                    let entity = this.currentModel.settings.childEntities.filter(x => x.clientId == this.selectedChild);
                    if (entity)
                        return entity[0].showOnlinePatientButton;
                }
                else if (!this.hasChildren && this.currentModel)
                    return this.currentModel.settings.showOnlinePatientButton;
                return true;
            }
        },
        mounted() {
            this.$store.dispatch('resetWalkinForm');
            this.$store.state.currentStep = 0;
        }
  }
</script>

<style scoped>
    .actions button {
        font-size: 18px;
        font-weight: 700;
        padding-left: 0;
        padding-right: 0;
        height: 90px !important;
        width: 100% !important;
        max-width: 370px !important;
    }
    .entity-selector { max-width: 370px; }
</style>